@switch (columnName) {
  @case ('expires') {
    {{ element[columnName] | date }}
  }
  @case ('productName') {
    {{ element.name }}
  }
  @case ('currentQuantity') {
    {{ element.quantity }}
  }
  @case ('quantityType') {
    {{ element.quantityType?.name }}
  }
  @case ('minQuantity') {
    {{ element.minimumQuantity }}
  }
  @case ('chemical') {
    @if (element.isChemical) {
      <mat-icon>science</mat-icon>
    }
  }
  @case ('critical') {
    @if (element.isCritical || element.isHazardousMaterial) {
      <mat-icon>warning</mat-icon>
    }
  }
  @case ('components') {
    @for (component of element.components; track component?.id ?? component) {
      <div>
        {{ (component?.sfiCode ? component.sfiCode + ' ' : '') + component?.name || '-' }}
      </div>
    }
  }
  @case ('description') {
    {{ element.reason }}
  }
  @case ('status') {
    <app-ui-pill [name]="statusColor"></app-ui-pill>
  }
  @case ('department') {
    {{ element.department.name }}
  }
  @case ('date') {
    {{ element.date | date }}
  }
  @case ('changedBy') {
    {{ element.changedBy | fullName }}
  }
  @case ('event') {
    {{ element.storageProductAction | mapProductAction | translate }} {{ transferDepartmentLabel }}
  }
  @default {
    <app-default-cell [element]="element" [columnName]="columnName"></app-default-cell>
  }
  @case ('actionButton') {
    <div class="display-flex">
      <app-ui-button
        text="{{ 'addToStock' | translate }}"
        buttonType="secondary"
        (click)="addToStock()"
        [loading]="(addToStockActions | actionInProgress: false : matchesRow | async) === true"
        privilege="STORAGE-PRODUCT_UPDATE"
      ></app-ui-button>
      <app-ui-button
        class="use-button"
        buttonType="secondary"
        text="{{ 'use' | translate }}"
        (click)="use()"
        [loading]="(useActions | actionInProgress: false : matchesRow | async) === true"
        privilege="STORAGE-PRODUCT_UPDATE"
      ></app-ui-button>
      @if (hasMultipleDepartments()) {
        <app-ui-button
          buttonType="secondary"
          text="{{ 'transfer' | translate }}"
          (click)="openTransferDialog()"
          [privilege]="Privileges.StorageProductTransfer"
          [disabled]="element.quantity < 1"
          [tooltip]="(element.quantity < 1 ? 'insufficientStockForTransfer' : '') | translate"
        ></app-ui-button>
      }
      @if (currentDepartmentId() !== allDepsToken) {
        @if (isInCart()(element.id)) {
          <app-ui-button
            buttonType="icon-button"
            icon="remove_shopping_cart"
            tooltip="{{ 'removeFromCart' | translate }}"
            (click)="removeFromCart()"
          ></app-ui-button>
        } @else {
          <app-ui-button
            buttonType="icon-button"
            icon="add_shopping_cart"
            tooltip="{{ 'addToCart' | translate }}"
            (click)="addToCart($event)"
          ></app-ui-button>
        }
      }
    </div>
  }
}
